// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'more';

export const Component = () => (
  <path
    fill='currentColor'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M7.92 2.52c0 .576.432 1.08 1.08 1.08s1.08-.504 1.08-1.08S9.576 1.44 9 1.44s-1.08.504-1.08 1.08zm0 6.48c0 .576.504 1.08 1.08 1.08s1.08-.504 1.08-1.08S9.576 7.92 9 7.92 7.92 8.424 7.92 9zm0 6.48c0 .576.504 1.08 1.08 1.08s1.08-.504 1.08-1.08S9.576 14.4 9 14.4c-.576-.072-1.08.504-1.08 1.08z'
  />
);

export const viewBox = '0 0 18 18';
